module.exports = __webpack_public_path__ + "img/s5pc.78c344bd.png";